window.customElements.define('fostr-blog-categories-bhg', class FostrBlogCategoriesBhg extends HTMLElement {

  constructor () {
    super();
  }

  connectedCallback () {
    this.initializeSlider();
    this.initializeResizeEvent();
  }

  initializeSlider () {
    const swiper = new Swiper('[fostr-blog-categories-bhg]', {
      slidesPerView: 'auto',
      slidesPerView: 3.2,
      spaceBetween: 10,
      pagination: {
        el: '.fostr-blog-categories__pagination',
        clickable: true
      }
    });

    if (window.innerWidth >= 960) {
      if (swiper.initialized) {
        swiper.destroy();
      }
    }
  }

  initializeResizeEvent () {
    window.addEventListener('resize', this.initializeSlider)
  }
})